import { Button } from '@material-ui/core'
import { ButtonProps } from '@material-ui/core/Button'
import { withLink, WithLinkProps } from '../ButtonLink/withLink'

export type Props = WithLinkProps<ButtonProps>
export const LegacyButtonLink = withLink<Props, ButtonProps>(Button)
export default LegacyButtonLink
